import PurchaseHistory from "@/pages/Histories/PurchaseHistory/PurchaseHistory";
import OutputHistory from "@/pages/Histories/OutputHistory/OutputHistory";
import InUseHistory from "@/pages/Histories/InUseHistory/InUseHistory";
import UsageHistory from "@/pages/Histories/UsageHistory/UsageHistory";
import OtherMovementsHistory from "@/pages/Histories/OtherMovementsHistory/OtherMovementsHistory";
import HistoriesHome from "@/pages/Histories/Home/HistoriesHome";

const userRole = () => ["administrador", "gerente_agricola", "administrador_campo", "usuario"];

export const historiesRoutes = [
	{
		path: `/historiales/compra`,
		Component: PurchaseHistory,
		roles: userRole(),
	},
	{
		path: `/historiales/salida`,
		Component: OutputHistory,
		roles: userRole(),
	},
	{
		path: `/historiales/en_uso`,
		Component: InUseHistory,
		roles: userRole(),
	},
	{
		path: `/historiales/usos`,
		Component: UsageHistory,
		roles: userRole(),
	},
	{
		path: `/historiales/otros_movimientos`,
		Component: OtherMovementsHistory,
		roles: userRole(),
	},
	{
		path: `/historiales`,
		Component: HistoriesHome,
		roles: userRole(),
	},
];
